import React from "react";
import CreateCircleTour from "./CreateCircleTour";
import CirclesPageTour from "./CirclesPageTour";

const TourManager: React.FC = () => {
  return (
    <>
      <CreateCircleTour />
      <CirclesPageTour />
    </>
  );
};

export default TourManager;
